import styled from "styled-components";
import Overlay from "../../Componentes/Overlay";
import Modal from "../../Componentes/Utils/Modal";
import DataTable from "../../Componentes/Utils/DataTable";
import useApi from "../../hooks/useApi";
import SmallLoading from "../../Componentes/Utils/SmallLoading";
import { useState } from "react";
import { useToast } from "../../contexts/ToastContext";

const Title = styled.h2`
    margin: 0 0 15px 0;
    font-size: 18px;
    color: var(--ctrl-text, #333);
`;

const Subtitle = styled.p`
    margin: 0 0 12px 0;
    font-size: 14px;
    color: var(--ctrl-text-muted, #555);
`;

const TableWrapper = styled.div`
    width: 100%;
    max-height: 60dvh;
    overflow: auto;
    border: 1px solid var(--ctrl-border, #ddd);
    border-radius: 8px;
`;

const EmptyText = styled.p`
    margin: 0;
    font-size: 14px;
    color: var(--ctrl-text-muted, #666);
`;

const LoadingWrapper = styled.div`
    width: 100%;
    min-height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const Coluna = styled.td`
    text-align: ${({ align }) => align || "left"};
`;

const formatQuantidade = (value) => {
    const numValue = typeof value === "string" ? parseFloat(value) : value;

    if (isNaN(numValue)) return " - ";

    return numValue.toLocaleString("pt-BR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

const ModalItensSolicitacao = ({ fecharModal, solicitacao, itens, loadingItens }) => {
    const api = useApi();
    const { notifyError } = useToast();
    const [pdfLoading, setPdfLoading] = useState(false);

    const imprimirSolicitacao = async () => {
        if (!solicitacao?.FILIAL || !solicitacao?.NUM_SOLICITACAO) return;

        setPdfLoading(true);
        try {
            const response = await api.post(
                "Painel/API/Controladoria/GeneratePDFSC/index.php",
                {
                    filial: solicitacao.FILIAL,
                    num_solicitacao: solicitacao.NUM_SOLICITACAO
                },
                { responseType: "blob" }
            );

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = `Solicitacao_${solicitacao.NUM_SOLICITACAO}.pdf`;
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (e) {
            notifyError(e?.response?.data?.message || "Erro ao gerar o PDF da solicitação.");
        } finally {
            setPdfLoading(false);
        }
    };

    return (
        <Overlay state={true}>
            <Modal size="lg" header close={fecharModal}>
                <Title>Itens da Solicitação</Title>
                <Subtitle>
                    Solicitação: <strong>{solicitacao?.NUM_SOLICITACAO}</strong> | Filial: <strong>{solicitacao?.FILIAL}</strong>
                </Subtitle>

                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 12 }}>
                    <button
                        type="button"
                        onClick={imprimirSolicitacao}
                        disabled={pdfLoading || loadingItens}
                        style={{
                            height: 34,
                            padding: "0 14px",
                            border: "1.2px solid var(--ctrl-border, #d3d3d3)",
                            borderRadius: 4,
                            backgroundColor: pdfLoading || loadingItens ? "var(--ctrl-surface-muted, #f0f0f0)" : "transparent",
                            cursor: pdfLoading || loadingItens ? "not-allowed" : "pointer",
                            color: "var(--ctrl-text, #333)"
                        }}
                    >
                        {pdfLoading ? "Gerando PDF..." : "Imprimir Solicitação de Compra"}
                    </button>
                </div>

                {loadingItens ? (
                    <LoadingWrapper>
                        <SmallLoading text="Carregando itens da solicitação..." />
                    </LoadingWrapper>
                ) : itens.length === 0 ? (
                    <EmptyText>Nenhum item encontrado para esta solicitação.</EmptyText>
                ) : (
                    <TableWrapper>
                        <DataTable>
                            <thead>
                                <tr>
                                    <th>ITEM</th>
                                    <th>CÓDIGO</th>
                                    <th>PRODUTO</th>
                                    <th>OBS.</th>
                                    <th>QUANTIDADE</th>
                                    <th>UNIDADE</th>
                                    <th>OBRA</th>
                                    <th>PREV. ENTR.</th>
                                </tr>
                            </thead>
                            <tbody>
                                {itens.map((item) => (
                                    <tr key={item.ID}>
                                        <td>{item.ITEM || " - "}</td>
                                        <td>{item.CODIGO || " - "}</td>
                                        <td>{item.NOME_ITEM || " - "}</td>
                                        <td>{item.OBS || " - "}</td>
                                        <Coluna align="right">{formatQuantidade(item.QUANTIDADE)}</Coluna>
                                        <Coluna align="center">{item.UNIDADE || " - "}</Coluna>
                                        <Coluna align="center">{item.OBRA || " - "}</Coluna>
                                        <Coluna align="center">{item.PREV_ENTR || " - "}</Coluna>
                                    </tr>
                                ))}
                            </tbody>
                        </DataTable>
                    </TableWrapper>
                )}
            </Modal>
        </Overlay>
    );
};

export default ModalItensSolicitacao;
